import { OnSiteLocationType, OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  header: 'Histórico de pedidos',
  labels: {
    dummy_order: 'Pedido de teste',
    orders_number: 'Número de pedidos ({{count}})',
    revenue: 'Receita: {{amount}}',
    tips: 'Gorjetas: {{amount}}',
    cash_sales: ' ({{amount}} Dinheiro)',
    refunds: 'Reembolsos: {{count}} ({{amount}})',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Levantamento',
    [OrderMethod.Delivery]: 'Entrega',
    [OrderMethod.OnSite]: {
      [OnSiteLocationType.RoomService]: 'Serviço de quarto',
      [OnSiteLocationType.TableService]: 'Serviço de mesa',
    },
  },
  statuses: {
    [OrderFulfillmentStatus.Created]: 'Em curso',
    [OrderFulfillmentStatus.Reviewed]: 'Em curso',
    [OrderFulfillmentStatus.Accepted]: 'Em curso',
    [OrderFulfillmentStatus.Preparing]: 'Em curso',
    [OrderFulfillmentStatus.Ready]: 'Em curso',
    [OrderFulfillmentStatus.OnDelivery]: 'Em curso',
    [OrderFulfillmentStatus.Picked]: 'Concluído',
    [OrderFulfillmentStatus.Rejected]: 'Rejeitado',
  },
  payment_methods: {
    invoice: 'Fatura',
    cash: 'Dinheiro',
    online: 'Método online',
  },
  filters: {
    all: 'Todos',
  },
  fields: {
    order_placed: 'Pedido efetuado',
    order_number: '#',
    customer: 'Cliente',
    payment_method: 'Método de pagamento',
    method: 'Tipo',
    status: 'Estado',
    total: 'Total',
  },
  buttons: {
    print: 'Imprimir',
    create_test_order: 'Criar pedido de teste',
  },
  toasts: {
    failed_to_fetch_orders: 'Falha ao carregar dados. Clique no ícone "atualizar" ou tente novamente em 1 minuto.',
    something_went_wrong: 'Ocorreu um erro, tente novamente.',
    failed_to_create_test_order: 'Falha ao criar pedido de teste',
    test_order_created: 'Pedido de teste criado',
  },
};
